import { render, staticRenderFns } from "./WApp.vue?vue&type=template&id=3cf59d10&"
import script from "./WApp.vue?vue&type=script&setup=true&lang=js&"
export * from "./WApp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports